import type { DisciplineFilesStore } from './interfaces'

export const getters = {
  isLoading: (state: DisciplineFilesStore): DisciplineFilesStore['loading'] => state.loading,
  getPacks: (state: DisciplineFilesStore): DisciplineFilesStore['packs'] => state.packs,
  hasPacks: (state: DisciplineFilesStore): boolean => state.packs.length > 0,
  getTasks: (state: DisciplineFilesStore): DisciplineFilesStore['tasks'] => state.tasks,
  getMeta: (state: DisciplineFilesStore): DisciplineFilesStore['meta'] => state.meta,
  getFilters: (state: DisciplineFilesStore): DisciplineFilesStore['filters'] => state.filters,
  getCurrentPage: (state: DisciplineFilesStore): DisciplineFilesStore['currentPage'] => state.currentPage,
  getPerPage: (state: DisciplineFilesStore): DisciplineFilesStore['perPage'] => state.perPage,
  getActiveModal: (state: DisciplineFilesStore): DisciplineFilesStore['activeModal'] => state.activeModal,
  getActivePackId: (state: DisciplineFilesStore): DisciplineFilesStore['activePackId'] => state.activePackId,
}
